import { Card, Grid, Image, Spacer, Text, useMediaQuery } from '@geist-ui/react'
import { Project } from '../projects'

export const ProjectTemplate = (
  props: {
    project: Project
  }
) => {
  const isMdUp = useMediaQuery('md', { match: 'up' })

  const headerFontSize = isMdUp ? '50px' : '30px'
  const titleFontSize = isMdUp ? '30px' : '20px'
  const subtitleFontSize = isMdUp ? '20px' : '15px'

  const { project } = props

  return (
    <Grid.Container gap={0} justify='center'>
      {/* Type header */}
      <Grid style={{ margin: 0 }} xs={24} justify='center'>
        <Text style={{ margin: 0 }} className='lato-light text-center' font={headerFontSize}>{project.type.toUpperCase()}</Text>
      </Grid>

      {/* Project Title */}
      <Grid style={{ margin: 0 }} xs={24} justify='center'>
        <Text style={{ margin: 0 }} className='lato-light text-center newline' font={titleFontSize}>{project.title.toUpperCase()}</Text>
      </Grid>

      <Spacer h={3} />

      {/* Info & Project & Skills */}
      <Grid style={{ width: '100%', padding: '30px' }}>
        <Grid.Container gap={2} justify='space-between'>

          {/* Info */}
          <Grid xs={24} md={8} justify='center'>
            <Card width={100} style={{ borderRadius: '20px' }}>
              <Card.Content>
                {
                  project.info.kind === 'client' ? <>
                    {/* If project is a client one */}
                    <Text style={{ marginBottom: '10px' }} className='lato-light' font={titleFontSize}>INFO</Text>

                    {/* Client */}
                    <Text style={{ marginBottom: '0px' }} className='lato-light' font={subtitleFontSize}>CLIENTE</Text>
                    <Text style={{ marginTop: '0px', borderLeft: '1px solid black', paddingLeft: '10px' }} className='lato-light'>{project.info.client}</Text>

                    {/* Location */}
                    <Text style={{ marginBottom: '0px' }} className='lato-light' font={subtitleFontSize}>PROJECT LOCATION</Text>
                    <Text style={{ marginTop: '0px', borderLeft: '1px solid black', paddingLeft: '10px' }} className='lato-light'>{project.info.location}</Text>

                    {/* Con */}
                    {
                      project.info.con && <>
                        <Text style={{ marginBottom: '0px' }} className='lato-light' font={subtitleFontSize}>CON</Text>
                        <Text style={{ marginTop: '0px', borderLeft: '1px solid black', paddingLeft: '10px' }} className='lato-light'>{project.info.con}</Text>
                      </>
                    }
                  </> : <>
                    {/* Otherwise, if project is a book one */}
                    <Text style={{ marginBottom: '10px' }} className='lato-light' font={titleFontSize}>INFO</Text>

                    {/* Authors */}
                    <Text style={{ marginBottom: '0px' }} className='lato-light' font={subtitleFontSize}>AUTORI E ILLUSTRATRICE</Text>
                    <Text style={{ marginTop: '0px', borderLeft: '1px solid black', paddingLeft: '10px' }} className='lato-light'>{project.info.authors}</Text>

                    {/* Code */}
                    <Text style={{ marginBottom: '0px' }} className='lato-light' font={subtitleFontSize}>{project.info.codeLabel.toUpperCase()}</Text>
                    <Text style={{ marginTop: '0px', borderLeft: '1px solid black', paddingLeft: '10px' }} className='lato-light'>{project.info.codeValue}</Text>

                    {/* Editor */}
                    <Text style={{ marginBottom: '0px' }} className='lato-light' font={subtitleFontSize}>EDITORE</Text>
                    <Text style={{ marginTop: '0px', borderLeft: '1px solid black', paddingLeft: '10px' }} className='lato-light'>{project.info.editor}</Text>
                  </>
                }
              </Card.Content>
            </Card>
          </Grid>

          {/* Project */}
          <Grid xs={24} md={8} justify='center'>
            <Card width={100} style={{ borderRadius: '20px' }}>
              <Card.Content>
                <Text style={{ marginBottom: '10px' }} className='lato-light' font={titleFontSize}>PROJECT</Text>

                {/* Project text */}
                <Text style={{ marginBottom: '0px' }} className='lato-light newline'>{project.projectText}</Text>
              </Card.Content>
            </Card>
          </Grid>

          {/* Skills */}
          <Grid xs={24} md={8} justify='center'>
            <Card width={100} style={{ borderRadius: '20px' }}>
              <Card.Content>
                <Text style={{ marginBottom: '10px' }} className='lato-light' font={titleFontSize}>SKILLS</Text>

                {/* Skills */}
                <Grid.Container style={{ borderLeft: '1px solid black', paddingLeft: '10px' }}>
                  {
                    project.skills.map((skill, index) => (
                      <Grid key={index} style={{ margin: 0 }} xs={24} justify='flex-start'>
                        <Text style={{ margin: 0 }} className='lato-light'>{skill}</Text>
                      </Grid>
                    ))
                  }
                </Grid.Container>
              </Card.Content>
            </Card>
          </Grid>

        </Grid.Container>
      </Grid>

      {/* Images */}
      <Grid style={{ width: '100%', padding: '30px' }} justify='center'>
        <Grid.Container gap={4} justify='center'>
          {
            project.images.map((image, index) => (
              <Grid key={index} xs={24} md={12} justify='center'>
                <Image src={image} alt='project' style={{ width: '100%' }} />
              </Grid>
            ))
          }
        </Grid.Container>
      </Grid>

      <Spacer h={6} />

    </Grid.Container>
  )
}
